import { api } from './api';
import { ApiResponse } from '@meradio/shared-types';

export interface LikeResponse {
  liked: boolean;
  like: {
    id: string;
    createdAt: string;
  } | null;
}

export interface LikedVideo {
  video: {
    id: string;
    videoId: string;
    title: string;
    description?: string;
    thumbnailUrl?: string;
    publishedAt: string;
    channel: {
      id: string;
      channelId: string;
      name: string;
      thumbnailUrl?: string;
    };
  };
  likedAt: string;
}

export interface UserLikesResponse {
  likes: LikedVideo[];
  pagination: {
    limit: number;
    offset: number;
    hasMore: boolean;
  };
}

export const toggleLike = async (videoId: string): Promise<LikeResponse> => {
  if (!videoId || videoId.trim().length === 0) {
    throw new Error('Video ID is required');
  }

  const response = await api.post<LikeResponse>('/likes/toggle', { videoId });
  
  if (!response.success || !response.data) {
    throw new Error(response.error || 'Failed to toggle like');
  }
  
  return response.data;
};

export interface GetUserLikesParams {
  limit?: number;
  offset?: number;
}

export const getUserLikes = async (params: GetUserLikesParams = {}): Promise<UserLikesResponse> => {
  const { limit = 20, offset = 0 } = params;

  const response = await api.get<UserLikesResponse>('/likes/user', {
    params: { limit, offset }
  });
  
  if (!response.success || !response.data) {
    throw new Error(response.error || 'Failed to get user likes');
  }
  
  return response.data;
};

